import { ViagensApi } from "@/api/viagens.api";
import { Viagens } from "@/models/viagens";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";

const api = new ViagensApi();

const getTravel = (
  page: number,
  size: number,
  idOrigem: number,
  idDestino: number,
  dataInicio: string,
  dataFim: string
): AxiosObservable<Viagens> =>
  api.getTravel(page, size, idOrigem, idDestino, dataInicio, dataFim);

const details = (id: number): AxiosObservable<Viagens> => api.details(id);

const create = (body: Viagens): AxiosObservable<Viagens> => api.create(body);

const finishTravel = (
  id: number,
  dataFim: string,
  latitude: string,
  longitude: string
): AxiosObservable<Viagens> => api.finishTravel(id, dataFim ,latitude, longitude);

const returnTravel = (body: Viagens): AxiosObservable<Viagens> =>
  api.returnTravel(body);

const activeTravel = (): AxiosObservable<Viagens> => api.activeTravel();

const permissionBackTravel = (id: string): AxiosObservable<Viagens> =>
  api.permissionBackTravel(id);

export default {
  getTravel,
  details,
  create,
  finishTravel,
  returnTravel,
  activeTravel,
  permissionBackTravel,
};
